import app from "./../app";
import _ from "./../libs/lodash";

import helperPlan from "./../helpers/plans";
import teamModel from "./../models/team";

import enterprise_icon from "./../svg/pricing/enterprise.svg";
import students_icon from "./../svg/pricing/students.svg";
import backIconPrice from "./../svg/pricing/back_price.svg";

import tooltip_lamp_icon from "./../svg/pricing/pricing-tooltip-lamp.svg"
import price_mark from "./../svg/pricing/check-mark.svg";
import iconNumberOne from "./../svg/pricing/number_one.svg";
import iconNumberTwo from "./../svg/pricing/number_two.svg";
import iconNumberThree from "./../svg/pricing/number_three.svg";
import iconPlayHover from "./../svg/pricing/icon_play-hover.svg";
import icon_info_grey from "./../svg/pricing/info_ico_grey.svg";
import closer from "./../svg/ic_close.svg";


import lock_blocked from "./../svg/pricing/lock-blocked.svg";
import save20_icon from "./../svg/pricing/save20.svg";
import closeCross from "./../svg/ic_close.svg";
import planModel from "../models/plans";
import moment from "../libs/moment";
import globalStore from "$$store/main";

const __ = window.__;

const innerObject = {};

export default (() => {
  if (!app.config.mode.isBase) {
    return {
      handle: function () {
      },
      getMainPaymentTemplate: function () {
      },
      setMainTextHeader: function () {
      },
      getMainPaymentTemplateStudent: function () {
      },
    };
  }
  const innerSettings = {
    paymentPeriod: 'year'
  };

  var innerTemplates = {
    getPaymentHeader: function () {
      const step = 5;
      let getAllRealResources = globalStore.getters['resourcesModel/getAllRealResources'];

      function toSum(_, index) {
        return String((+index + 1) * step);
      }

      function getCurrentPlan(plan) {
        if (plan - step < getAllRealResources.length && getAllRealResources.length <= plan) {
          return plan;
        }
      }

      const tmp = new Array(20).fill('').map(toSum);
      const getCaptionPlan = tmp.map(toSum).find(getCurrentPlan);

      return "<div class='payment-body-header'>" +
        this.getHeaderTooltipForAnnualy({
          plan: helperPlan.getDataPlanTeam(null, getCaptionPlan)
        }) +
        '<div class="radio-choose">' +
        '<span class="choose_txt js-radioPeriod" data-period="month">' + "<i>" + __("monthly") + "</i>" + '</span>' +
        '<span class="choose_radio" data-period="year"><i class="radio_slider"></i></span>' +
        '<span class="choose_txt js-radioPeriod selected" data-period="year">' + "<i>" + __("yearly") + "</i>" +
        '</span>' +
        '</div>' +
        "<div class='payment-body-header-text manage header-pricing-start'>" + __('pricing_header_business') + "</div>" +
        "<div class='payment-body-header-button white'>" +
        "<div class='arrow'>" +
        closeCross +
        "</div>" +
        "</div>" +
        "</div>";
    },
    getHeaderTooltip: function (isDiscount) {
      ///
      const saveTitleText = !isDiscount ? __('save20_title') : __('save50_title');

      return '<div class="payment-body-header-tooltip ">' +
        "<div class='payment-body-header-tooltip-container'>" +
        "<div class='triangle'></div>" +
        "<div class='payment-body-header-tooltip-column payment-body-header-tooltip-icon'>" + save20_icon + "</div>" +
        "<div class='payment-body-header-tooltip-column payment-body-header-tooltip-text'>" +
        "<h4>" + saveTitleText + "</h4>" +
        "<p>" + __('plan_billed_annually') + "</p>" +
        "</div>" +
        "</div>" +
        '</div>';
    },
    getHeaderTooltipForAnnualy: function (data) {
      const users = data.plan.teamUsers;
      const monthPrice = (data.plan.month.price * 12) * users;
      const yearPrice = (data.plan.year.price * 12) * users;
      const salePrice = monthPrice - yearPrice;
      let tooltipTitle;

      if(user.locale === 'kr') {
        tooltipTitle = '$' + salePrice + ' ' + __('pricing_tooltip_title')
      } else {
        tooltipTitle = __('pricing_tooltip_title') + ' ' + '$' + salePrice
      }

      return `<div id="annualyTooltip" class="payment-body-header-tooltip annualy">
                <div class="tooltip-closer">${closer}</div>
                <div class='payment-body-header-tooltip-container'>
                  <div class='payment-body-header-tooltip-icon'>${tooltip_lamp_icon}</div>
                  <div class='payment-body-header-tooltip-column payment-body-header-tooltip-text'>
                    <h4>${tooltipTitle}</h4>
                    <p>${__('tooltip_annual_description')}</p>
                  </div>
                </div>
              </div>`
    },
    getPaymentFooterBusinessEnterprice: function (data, css) {
      const imgCity = `<img class='content_img-pic' src='https://cdn.ganttpro.com/app/imgs/enterprise-city.png'>`;

      return `
          <div class="payment-body-container-block block-enterprice ${data.disabled ? ' action-block' : ''} ${css ? css : ''}">
            <div class="block__title">${__('enterprise')}</div>
            <div class='block__content'>
              <div class="content_img dnone">${imgCity}</div>
              <div class="content_title">${__('lets_talk')}</div>
              <div class="content_desc dnone">${__('enterprise_description')}</div>
              <div class="content_features_list">
                <span class="list_desc">${__('pricing_enterprice_list_description')}</span>
                <ul class="list">
                  <li>${price_mark}<span>${__("pricing_enterprise_features_01")}</span></li>
                  <li>${price_mark}<span>${__("pricing_enterprise_features_02")}</span></li>
                  <li>${price_mark}<span>${__("pricing_enterprise_features_03")}</span></li>
                  <li>${price_mark}<span>${__("pricing_enterprise_features_04")}</span></li>
                </ul>
              </div>
            </div>
            <div class="block__btn contact-us-button">${__("contact_us")}</div>
          </div>`
    },
    getPaymentFooterBusiness: function () {
      return `
          <div class="payment-body-footer business">
            <div class='payment-body-footer business-container'>
              <div class='footer-title'>${__('students_title')}</div>
              <div class='footer-text'>${__('students_description')}</div>
              <div class='footer-btn'>${__("learn_more")}</div>
            </div>
          </div>
      `;
    },
    getPaymentHorizontalPlanBlock: function (data, css) {
      var saleDOM = '';
      let hnyContent = '';

      if (user.affiliate && user.affiliate.percent && user.affiliate.coupon && user.affiliate.isStillValid) {
        // saleDOM = '<span class="coupon_label">-'+ (user.affiliate.isFixedDiscount ? '$' : '') + user.affiliate.percent + '<i>'+(user.affiliate.isFixedDiscount ? '' : '%')+'</i></span>'
        hnyContent = `
          <div class="payment-body-container-block-hny">
              <img src="${GT.cdn}/imgs/HNY/2020/red_lg.png">
          </div>`
      }

      let hnyLight = `
      <div class="payment-body-container-block-hny light">
            <img src="${GT.cdn}/imgs/HNY/2020/lighten.png">
        </div>`;

      var note = !_.isUndefined(data.note) ?
        "<div class='payment-body-container-block-price-note-value'>" + data.note + "</div>" : '';

      return "<div class='payment-body-container-block " + (css ? css : "") + (data.disabled ? ' disabled' : '') + "'>" +
        "<div class='payment-body-container-block-name'>" +
        data.name +
        "</div>" +
        "<div class='payment-body-container-block-price hidden' data-period='month'>" +
        "<div class='payment-body-container-block-price-value'>" + data.price.month + "</div>" +
        "</div>" +
        "<div class='payment-body-container-block-price' data-period='year'>" +
        "<div class='payment-body-container-block-price-value'>" + data.price.year + "</div>" +
        "</div>" +
        innerTemplates.getPlanButtonIndividual(data.plan) +
        (data.disabled ? innerTemplates.warningMessage() : "") + saleDOM +
        hnyContent +
        (data.hny ? hnyLight : '') +
        "</div>";
    },
    selectPlanBtn: function () {
      let paymentPeriod = innerSettings.paymentPeriod;
      let getAllRealResources = globalStore.getters['resourcesModel/getAllRealResources'];
      const step = 5; // step plans = 5,10...60
      const numberOfPlans = 10;
      let mainPlan = 40;

      let infoIcon = `
        <div class="option__info-icon tooltip-gantt" data-y='-6' data-key="can_not_use_plan">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z" fill="#424242"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3C8.55226 3 9 3.4486 9 4.00055C9 4.5525 8.55226 5 8 5C7.44774 5 7 4.5525 7 4.00055C7 3.4486 7.44774 3 8 3Z" fill="#424242"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 7.49992C7 7.22408 7.22324 7.00037 7.49908 7.00018C7.6466 7.00008 7.81781 7 8 7C8.18188 7 8.35281 7 8.50015 7C8.7763 7 9 7.22386 9 7.5V12.4994C9 12.7753 8.77668 12.999 8.50078 12.9992C8.3533 12.9992 8.18214 12.9993 8 12.9993C7.81844 12.9993 7.64778 12.9994 7.50061 12.9995C7.22417 12.9997 7 12.7757 7 12.4992V7.49992Z" fill="#424242"/>
          </svg>
        </div>`;

      function getCurrentPlan (plan) {
        if (plan - step < getAllRealResources.length && getAllRealResources.length <= plan) {
          mainPlan = plan;
          return plan;
        }
      }

      function getHTMLCurrentPlan(current = 40) {
        let currentPlan = 'team' + current;
        let currentText = __(`payment_switch_${current}`);

        return `<div class="caption" data-plan=${currentPlan} data-period=${paymentPeriod}>${currentText}</div>`
      }

      function toSum (_, index) {
        return String((+index+1)*step);
      }

      function toHTMLPlans (plan) {
        const classSelected = function () {
          if (getAllRealResources.length > mainPlan) {
            return (plan - step < getAllRealResources.length && getAllRealResources.length <= plan) ? 'selected' : '';
          }

          return +plan === +mainPlan ? 'selected': '';
        };
        const classDisabled = getAllRealResources.length > +plan ? 'disabled' : '';

        return `
              <div data-plan=${'team' + plan} class="changePlanOption ${classDisabled} ${classSelected()}">
                <span class="option_text"><strong>${plan}</strong> ${__('app_payment_switch')}</span>${infoIcon}
              </div>`
      }

      const plan = new Array(numberOfPlans).fill('').map(toSum).find(getCurrentPlan);
      const userPlansTemplate = new Array(numberOfPlans).fill('').map(toSum).map(toHTMLPlans).join('');
      const captionPlanTemplate = getHTMLCurrentPlan(plan);

      return `
          <div class="select-plan">
            <div class="container">
              <div class="dropdown">
                ${captionPlanTemplate}
                <div class="list">
                  ${userPlansTemplate}
                  <div class="plan-list-contact-us contact-us">${__('pricing_plans_list_contact_us')}</div>
                </div>
              </div>
            </div>
          </div>`;
    },
    getPlanButton: function (plan) {
      if (_.isUndefined(plan)) {
        return "<div class='payment-body-container-block-button free-plan'>" +
          '<div class="payment_btn">' + __('btn_upgrade') + '</div>' +
          "</div>";
      }

      return `
          <div class='payment-body-container-block-button' data-period='year'>
            <a data-key=${plan.yearKey} class="payment_btn" target="_blank" mark-plan=${plan.yearName}>${__("btn_upgrade")}</a>
          </div>
          <div class='payment-body-container-block-button contact-us' data-period='year'>
            <div class='contact-us_text' data-period='year'>${__("contact_us")}</div>
          </div>`;
    },
    getPlanButtonIndividual: function (plan) {
      if (_.isUndefined(plan)) {
        return "<div class='payment-body-container-block-button free-plan'>" +
          '<div class="payment_btn">' + __('btn_upgrade') + '</div>' +
          "</div>";
      }

      return "<div class='payment-body-container-block-button hidden' data-plan='pro' data-period='month'>" +
        // '<a data-key="' + plan.monthKey + '" class="payment_btn" target="_blank" ' +
        // 'mark-plan = "' + plan.monthName + '">' + __("btn_upgrade") +
        // '</a>' +
        "</div>" +
        "<div class='payment-body-container-block-button' data-plan='pro' data-period='year'>" +
        '<a data-plan="pro" data-period="year" class="payment_btn" target="_blank" ' +
        'mark-plan = "' + plan.yearName + '">' + __("btn_upgrade") +
        '</a>' +
        "</div>";
    },
    warningMessage: function () {
      return "<div class='payment-body-container-block-warning'>" +
        '<div class="payment-body-container-block-warning-icon">' + lock_blocked + '</div>' +
        '<div class="payment-body-container-block-warning-text">' + __('can_not_use_plan') + '</div>' +
        "</div>";
    },
    getTabbar: function (hidden) {
      return "<div class='payment-body-tabbar'>" +
        "<h1 class='payment-body-tabbar-header'>" + __('choose_the_plan') + "</h1>" +
        "<div class='payment-body-tabbar-container " + (hidden ? "hidden" : "") + "'>" +
        "<div class='payment-body-tabbar-tabs'>" +
        "<div class='payment-body-tabbar-tab' data-plans-type='individual'>" + __('individual_plans_tab') + "</div>" +
        "<div class='payment-body-tabbar-tab active' data-plans-type='business'>" + __('business_plans_tab') + "</div>" +
        "</div>" +
        "</div>" +
        "</div>";
    },
    paymentPlanStudentHeroHeader: function () {
      return "<div class='payment-body-header'>" +
        "<span class='payment-body-header-text back_btn'>" + backIconPrice + __('back_btn') + "</span>" +
        "<div class='payment-body-header-text manage'>" + __('student_page_title') + "</div>" +
        "<div class='payment-body-header-button white'>" +
        "<div class='arrow'>" +
        closeCross +
        "</div>" +
        "</div>" +
        "</div>";
    },
    paymentPlanStudentHero: function () {
      return "<div class='payment-body-student-page-hero'>" +

        "<div class='student-page-hero-container'>" +
        "<div class='student-page-hero-text'>" +
        "<div class='student-page-hero-title'>" + __('student_page_hero_title') + "</div>" +
        "<div class='student-page-hero-desc'>" + __('student_page_hero_desc') + "</div>" +
        "</div>" +
        "<div class='student-page-hero-pic'>" +
        `<img src='${GT.cdn}/imgs/pricing/student-hero-pic.png'>` +
        "</div>" +
        "</div>" +
        // "<div class='student-page-hero-addition'>" + __('student_page_hero_addition') + "</div>" +
        "</div>";
    },
    paymentPlanStudentMain: function () {
      var srcVideoStudentImage = __('student_video_bg_img');
      var srcVideoStudentSrc = __('student_video_src');
      var studentReviewLinkLocale = 'student_review_link_' + ((Math.ceil(window.user.id) % 20) + 1);

      return "<div class='payment-body-student-page-main'>" +
        "<div class='student-main-container student-main-container-left'>" +

        //header
        "<div class='student-main-head'>" +
        "  <div class='student-main-head-title'>" + __('student_main_head_title') + "</div>" +
        "    <div class='student-main-head-tabs'>" +
        "      <div class='tab-button js-tabs-left active-left'>" +
        "        <div class='tab-button-title'>" + __('student_main_head_tabs_left_title') + "</div>" +
        "        <div class='tab-button-link'>" + __('student_main_head_tabs_left_link') + "</div>" +
        "      </div>" +
        "      <div class='tab-button js-tabs-right'>" +
        "        <div class='tab-button-title'>" + __('student_main_head_tabs_right_title') + "</div>" +
        "        <div class='tab-button-link'>" + __('student_main_head_tabs_right_link') + "</div>" +
        "      </div>" +
        "      <div class='after-line'>" + "</div>" +
        "    </div>" +
        "</div>" +

        "<div id='left' class='student-main-layout student-main-layout-left js-show-student-main-content-left'>" +
        "  <div class='student-main-content'>" +
        "    <div class='content-text-one-capterra'>" +
        // "      <div class='capterra-text'>" + __('content_box_video_text_right') +
        // "        <a href=" + __('student_review_link') + " target='_blank' class='capterra-text-link'>" + __('student_link_review') + "</a>" +
        // "      </div>" +
        "         <div class='capterra-text'>" + __('content_box_video_text_right_link_before') + ' ' + __(studentReviewLinkLocale) + '<br>' + __('content_box_video_text_right_link_after') + "</div>" +
        "      <div class='content-text-one-capterra-number'>" + iconNumberOne + "</div>" +
        "    </div>" +
        "    <div class='content-text-two-capterra'>" +
        "      <div class='capterra-text'>" + __('content_box_video_text_right_02') + "</div>" +
        "      <div class='content-text-two-capterra-number'>" + iconNumberTwo + "</div>" +
        "    </div>" +
        "    <div class='content-text-three-capterra'>" +
        "    <div class='capterra-text'>" + __('form_btn_desc_text_year') + "</div>" +
        "    <div class='content-text-three-capterra-number'>" + iconNumberThree + "</div>" +
        "      <form class='contact_form' enctype='multipart/form-data'>" +
        "        <div class='form_cell'>" +
        "          <input id='js-form-validation-year' class='form_input-year' type='url' placeholder='" + __('student_form_input_placeholder') + "' name='url'>" +
        "        <div class='capterra-text'>" + __('form_btn_desc_text_review_year') + "</div>" +
        "        <div class='form_cell-review'>" +
        "          <p class='form_error-year-review isVisible'>" + __('from_error_text') + "</p>" +
        "          <input id='js-form-validation-review-year' class='form_input-review-year' type='url' placeholder='" + __('student_form_input_placeholder') + "' name='url'>" + "</div>" +
        "      <div class='form_btn'>" +
        "        <a class='form-btn-link-year'>" + __('common_done') + "</a>" +
        "      </div>" +
        "          <p class='form_error-year isVisible'>" + __('from_error_text') + "</p>" +
        "        </div>" +
        "      </form>" +
        "      <div class='form-btn-desc-link'>" + __('form_btn_desc_text') + "</div>" +
        "    </div>" +
        "  </div>" +
        "</div>" +

        "<div id='right' class='student-main-layout student-main-layout-right'>" +

        "  <div class='student-main-content'>" +
        "    <div class='content-box-video'>" +
        "      <div class='video-text'>" + __('content_box_video_text') + "</div>" +
        "      <div class='video-desc'>" + __('content_box_video_desc') + "</div>" +
        "      <div class='video-number'>" + iconNumberOne + "</div>" +
        "      <div class='video-box'>" +
        "        <div class='video-box-play hover'>" + iconPlayHover + "</div>" +
        "        <img class='promo-video-image js-show-global-video-fullscreen' data-video-src='" + srcVideoStudentSrc + "' src='" + srcVideoStudentImage + "' data-video-class='ratio_16-8-3725'>" +
        "      </div>" +
        "    </div>" +
        "    <div class='content-text-two'>" +
        "      <div class='video-text'>" + __('content_box_video_text_02') + "</div>" +
        "      <div class='video-number-two'>" + iconNumberTwo + "</div>" +
        "    </div>" +
        "    <div class='content-text-three'>" +
        "    <div class='video-text'>" + __('content_box_video_text_03') + "</div>" +
        "    <div class='video-number-three'>" + iconNumberThree + "</div>" +
        "      <form class='contact_form'>" +
        "        <div id='form_cell_student' class='form_cell'>" +
        "          <input id='js-form-validation' class='form_input' type='url' placeholder='" + __('student_form_input_placeholder') + "' name='url'>" +
        "        <div class='video-text'>" + __('content_box_video_text_03_student_id') + "</div>" +
        "        <div class='form_cell-student'>" +
        "          <p class='form_error-student isVisible'>" + __('from_error_text') + "</p>" +
        "          <input id='js-student-id-form-validation' class='form_input-student' type='url' placeholder='" + __('student_form_input_placeholder') + "' name='url'>" +  "</div>" +
        "          <div class='form-btn'>" +
        "            <a class='form-btn-link'>" + __('common_done') + "</a>" +
        "          </div>" +
        "          <p class='form_error isVisible'>" + __('from_error_text') + "</p>" +
        "        </div>" +
        "      </form>" +
        "      <div class='form-btn-desc-link'>" + __('form_btn_desc_text') + "</div>" +
        "    </div>" +
        "  </div>" +


        "</div>" +

        "</div>" +
        "</div>";
    },
    paymentPlanStudentBottom: function () {
      return "<div class='payment-body-student-page-bottom'>" +

        "<div class='student-page-hero-container'>" +
        "<div class='student-page-hero-bottom-title'>" + __('student_page_hero_title_bottom') + "</div>" +
        "<div class='student-page-hero-bottom-pic'>" +
        "<div class='hero-bottom-pic one'>" + `<img src='${GT.cdn}/imgs/pricing/student-ochif/dpm.png'>` + "</div>" +
        "<div class='hero-bottom-pic one'>" + `<img src='${GT.cdn}/imgs/pricing/student-ochif/univer_michigan.png'>` + "</div>" +
        "<div class='hero-bottom-pic one'>" + `<img src='${GT.cdn}/imgs/pricing/student-ochif/stanford.png'>` + "</div>" +
        "<div class='hero-bottom-pic one'>" + `<img src='${GT.cdn}/imgs/pricing/student-ochif/vashington.png'>` + "</div>" +
        "<div class='hero-bottom-pic one'>" + `<img src='${GT.cdn}/imgs/pricing/student-ochif/poerto_rico.png'>` + "</div>" +
        "<div class='hero-bottom-pic one'>" + `<img src='${GT.cdn}/imgs/pricing/student-ochif/unver_cornell.png'>` + "</div>" +
        "</div>" +
        "</div>" +

        "</div>";
    },
    getPaymentIndividual: function (data, css) {
      let individualButton = innerTemplates.getPlanButtonIndividual(data.plan);
      let tillDate = `${data.discount ? `<div class="js-discount-price">${__("coupon_till").toLowerCase() + ' ' +
      innerObject.momentFormat()}</div>` : ''}`;
      return `
          <div class="payment-body-container-block block-individual ${data.disabled ? ' disabled' : ''} ${css ? css : ''}">
            <div class='payment-tooltip tooltip-gantt' data-y='-4' data-key='annual_users_tooltip'>${icon_info_grey}</div>
            <div class="block__title">${data.name}</div>
            <div class='block__price hidden' data-period='month'>
              <div class='block__price-value'>
                 <div class="value">${data.discount ? data.price_discount.month : data.price.month}</div>
                ${tillDate}
              </div>
              ${data.discount ? `<div class="block__price-old js-discount-price" data-period="month">
                                  <div class="value">${data.price.month}</div>
                                </div>` : ''}
              <div class="block__price-desc" data-period="month">
                <div class="desc">${data.price.desc}</div>
              </div>
            </div>
            <div class='block__price' data-period='year'>
              <div class='block__price-value'>
               <div class="value">${data.discount ? data.price_discount.year : data.price.year}</div>
                ${tillDate}
              </div>
              ${data.discount ? `<div class="block__price-old js-discount-price" data-period="year">
                                  <div class="value">${data.price.year}</div>
                                </div>` : ''}
              <div class="block__price-desc" data-period="year">
                <div class="desc">${data.price.desc}</div>
              </div>
            </div>
            <div class="plan__description individual"><p class="desc__text">${__('pricing_individual_plan_description')}</p></div>
            ${individualButton}
            ${data.disabled ? innerTemplates.warningMessage() : ""}
          </div>`;
    },
    getPaymentPlanBlockTen: function (data, css) {
      let selectPlanBtn = innerTemplates.selectPlanBtn(data);
      let upgradeBtn = innerTemplates.getPlanButton(data.plan);
      let tillDate = `${data.discount ? `<div class="js-discount-price">${__("coupon_till").toLowerCase() + ' ' +
      innerObject.momentFormat()}</div>` : ''}`;
      let blockPriceNote = `<div class="payment-body-container-block-price-note">
                <div class="payment-body-container-block-price-note-value">${__('user_per_month')}</div>
                <div class="payment-body-container-block-price-note-value-annual" data-period='year'>${__('billed_annualy')}</div>
              </div>`;

      return `
          <div class="payment-body-container-block ten-users ${css ? css : ''}">
            <div class="block__sticker">${__('pricing_team_block_sticker_text')}</div>
            <div class="block__title">${__('pricing_team_block_header_title')}</div>
            <div class="block__price hidden" data-period="month">
              <div class="block__price-value">
                ${data.discount ? data.price_discount.month : data.price.month}
                ${tillDate}
              </div>

              ${data.discount ? `<div class="block__price-old js-discount-price" data-period="month">
                                  ${data.price.month}
                                </div>` : ''}
              ${blockPriceNote}
            </div>
            <div class="block__price" data-period="year">
              <div class="block__price-value">
                    ${data.discount ? data.price_discount.year : data.price.year}
                  ${tillDate}
              </div>
               ${data.discount ? `<div class="block__price-old js-discount-price" data-period="year">
                                  ${data.price.year}
                                </div>` : ''}
              ${blockPriceNote}
            </div>
            <div class="plan__description team"><p class="desc__text">${__('pricing_team_plan_description')}</p></div>
            ${selectPlanBtn}
            ${upgradeBtn}
          </div>`
    },
    getPaymentPlanBlock: function (data, css) {
      return "<div class='payment-body-container-block " + (css ? css : "") + (data.disabled ? ' disabled' : '') + "'>" +
        "<div class='payment-body-container-block-fields'>" +
        "<div class='payment-body-container-block-price hidden' data-period='month'>" +
        "<div class='payment-body-container-block-price-value'>" +
        data.price.month +
        "</div>" +
        "</div>" +
        "<div class='payment-body-container-block-price' data-period='year'>" +
        "<div class='payment-body-container-block-price-value'>" +
        data.price.year +
        "</div>" +
        "</div>" +
        "<div class='payment-body-container-block-price-note'>" +
        "<div class='payment-body-container-block-price-note-value'>" + __('user_per_month') + "</div>" +
        "<div class='payment-body-container-block-price-note-value-annual' data-period='year'>" + __('billed_annualy') + "</div>" +
        "</div>" +
        "<div class='payment-body-container-block-upto'>" +
        data.upTo +
        "</div>" +
        "</div>" +

        (data.disabled ? innerTemplates.warningMessage() : innerTemplates.getPlanButton(data.plan)) +
        "</div>";
    },
    getPaymentBodyBusiness: function () {
      const step = 5;
      const mainPlan = 40;

      let planPro = helperPlan.getDataPlanPro();
      let getAllRealResources = globalStore.getters['resourcesModel/getAllRealResources'];

      function toSum(_, index) {
        return String((+index + 1) * step);
      }

      function getCurrentPlan(plan) {
        if (plan - step < getAllRealResources.length && getAllRealResources.length <= plan) {
          return plan;
        }
      }

      const tmp = new Array(20).fill('').map(toSum);
      const getCaptionPlan = tmp.map(toSum).find(getCurrentPlan);
      const isDiscount = document.body.classList.contains('isDiscount');

      return "<div class='payment-body-container business' data-plans-type='business'>" +
        // THIS TOOLTIP WAS BEFORE THE NEW PRICING
        // this.getHeaderTooltip({ discount: isDiscount }) +
        "<div class='payment-body-container-blocks'>" +
        this.getPaymentIndividual(
          {
            name: __("essential_name"),
            desc: __("desc_for_essential"),
            note: __("note_for_essential"),
            discount: planModel.getAffiliate(),
            price: {
              month: `
                <span class='span-price'>
                  ${planPro['month'].price}
                  <sup>${planPro.currencySymbol}</sup>
                </span>`,
              year: `
                <span class='span-price'>
                  ${planPro['year'].price}
                  <sup>${planPro.currencySymbol}</sup>
                </span>`,
              saveValue: (+planPro['month'].price - +planPro['year'].price) * 12,
              desc: `
                <div class="value-conditions">${__("user_per_month")}</div>
                <div class="value-conditions-desc">${__("pricing_plans_billed")}</div>`,
            },
            price_discount: {
              month: `
                <span class='span-price span-price_promotion'>
                ${innerObject.beautifyPrice((planPro['month'].price - planPro['month'].price / 100 * planModel.getAffiliate()).toFixed(2))}
                <sup>${planPro.currencySymbol}</sup>
                </span>`,
              year: `<span class='span-price span-price_promotion'>
                  ${innerObject.beautifyPrice((planPro['year'].price - planPro['year'].price / 100 * planModel.getAffiliate()).toFixed(2))}
                <sup>${planPro.currencySymbol}</sup>
                </span>`,
              saveValue: (+planPro['month'].price_discount - +planPro['year'].price_discount) * 12,
              desc: `
                <div class="value-conditions">${__("user_per_month")}</div>
                <div class="value-conditions-desc">${__("pricing_plans_billed")}</div>`,
            },
            features: [
              __("inapp_pricing_essential_1"),
              __("inapp_pricing_essential_2"),
              __("inapp_pricing_essential_3"),
              __("inapp_pricing_essential_4"),
            ],
            disabled: teamModel.getCountOfInvitedUsers() > 1,
            plan: innerObject.getPaymentPlanAttributes(planPro),
            hny: false,
          }) +
        this.getPaymentPlanBlockTen({
          name: __("big_team_name_pricing"),
          price: {
            month:`<div class='value'>` + "<sup>" + "$" + "</sup>" + (helperPlan.getDataPlanTeam('month', getCaptionPlan).priceTemplate) + `</div>`,
            year: `<div class='value'>` + "<sup>" + "$" + "</sup>" + (helperPlan.getDataPlanTeam('year', getCaptionPlan).priceTemplate) + `</div>`,
          },
          price_discount: {
            month: `<div class='value value_promotion'>` +  "<sup>" + "$" + "</sup>" +
              //(helperPlan.getDataPlanTeam('month', getCaptionPlan).price),
              innerObject.beautifyPrice((helperPlan.getDataPlanTeam('month', getCaptionPlan).price - helperPlan.getDataPlanTeam('month', getCaptionPlan).price / 100 * planModel.getAffiliate()).toFixed(2)) + `</div>`,
            year: `<div class='value value_promotion'>` + "<sup>" + "$" + "</sup>" +
              //(helperPlan.getDataPlanTeam('year', getCaptionPlan).price)
              innerObject.beautifyPrice((helperPlan.getDataPlanTeam('year', getCaptionPlan).price - helperPlan.getDataPlanTeam('year', getCaptionPlan).price / 100 * planModel.getAffiliate()).toFixed(2)) + `</div>`,

          },
          // plan: innerObject.getPaymentPlanAttributes(helperPlan.getDataPlanTeam('year', getCaptionPlan)),
          upTo: __('up_acc_to_10'),
          // disabled: teamModel.getCountOfInvitedUsers() > 10,
          bestLabel: __('plans_popup_most_popular'),
          hny: false,
          discount: planModel.getAffiliate(),
        }, 'best-plan') +
        this.getPaymentFooterBusinessEnterprice({
          disabled: teamModel.getCountOfInvitedUsers() > 15,
        }) +
        "</div>" +
        // This block was with a list of features
        // "<div class='payment-body-container-blocks'>" +
        // "   <div class='payment-body-container-blocks-features'>" +
        // "     <ul>" +
        // "       <li>" + price_mark + "<span>" + __("pricing_team_features_01") + "</span></li>" +
        // "       <li>" + price_mark + "<span>" + __("pricing_team_features_02") + "</span></li>" +
        // "       <li>" + price_mark + "<span>" + __("pricing_team_features_03") + "</span></li>" +
        // "       <li>" + price_mark + "<span>" + __("pricing_team_features_04") + "</span></li>" +
        // "       <li>" + price_mark + "<span>" + __("pricing_team_features_05") + "</span></li>" +
        // "    </ul>" +
        // " </div>" +
        // "</div>" +
        "</div>";
    }
  };

  var innerObject = {
    handle: function () {
      this.initPeriodSlider();
      this.initButtonBuyClick();
      this.initHoverAnimation();
      this.initBoxShadowPriceMoreUsers();

      _.delay(() => {
        this.returnDefaultPeriodPayment();
      });
    },
    getPaymentPlanAttributes: function (plan) {
      return {
        monthKey: plan.monthKey,
        monthName: plan.monthName,
        yearKey: plan.yearKey,
        yearName: plan.yearName
      };
    },
    returnDefaultPeriodPayment: () => {
      if ($$('paymentPlanInfoPopup')) {
        const $$paymentPlanInfoPopup = $$('paymentPlanInfoPopup');
        if ($$paymentPlanInfoPopup.getNode() && $$paymentPlanInfoPopup.getNode().querySelector('.select-plan .caption')) {
          let bestPlanSelect = $$('paymentPlanInfoPopup').getNode().querySelector('.select-plan .caption');

          bestPlanSelect.setAttribute('data-period', 'year');
        }
      }
    },
    initBoxShadowPriceMoreUsers: function () {
      var priceFiveNode = document.querySelector('.five-users');
      var priceTenNode = document.querySelector('.ten-users');
      var priceTenFifteen = document.querySelector('.fifteen-users');

      if (!priceFiveNode || !priceTenNode || !priceTenFifteen) {
        return;
      }

      var blockPriceFive = priceFiveNode.classList.contains('disabled-five-users');
      var blockPriceTen = priceTenNode.classList.contains('disabled-ten-users');
      var blockPriceFifteen = priceTenFifteen.classList.contains('disabled-fifteen-users');

      if (blockPriceFive && blockPriceTen && !blockPriceFifteen) {
        document.querySelector('.fifteen-users').classList.add('action-block-price');
      } else {
        return false;
      }
    },
    initHoverAnimation: function () {
      var containers = document.querySelectorAll(".business .payment-body-container-block:not(.best-plan)"),
        bestPlan = document.querySelector('.business .best-plan'),
        handlerFunction = _.debounce(function (state) {
          if (state) {
            bestPlan.classList.add('no-hover');
          } else {
            bestPlan.classList.remove('no-hover');
          }
        }, 100);

      if (!bestPlan) {
        return;
      }

      _.each(containers, function (container) {
        container.onmouseenter = function (e) {
          handlerFunction(true);
        };

        container.onmouseleave = function (e) {
          handlerFunction(false);
        };
      });
    },
    initPeriodSlider: function () {
      var radioPeriod = document.getElementsByClassName("radio-choose")[0],
        slider = document.getElementsByClassName("choose_radio")[0];

      if (!radioPeriod) return;
      radioPeriod.onclick = function (e) {
        var elem = e.target;

        if (elem.tagName === "I" && elem.className === "") {
          elem = elem.parentElement;
        }

        var period = elem.getAttribute('data-period'),
          newPeriod,
          lastPeriod;

        if (!_.isString(elem.className) ||
          (elem.className.indexOf("js-radioPeriod") === -1 && elem.className.indexOf("choose_radio") === -1)) {
          return false;
        }

        if (elem.className.indexOf("js-radioPeriod") !== -1) {
          newPeriod = period;
        } else if (elem.className.indexOf("choose_radio") !== -1) {
          newPeriod = period === 'year' ? 'month' : 'year';
        }

        lastPeriod = (newPeriod === 'year' ? 'month' : 'year');

        radioPeriod.querySelector('.choose_txt[data-period="' + lastPeriod + '"]').classList.remove('selected');
        radioPeriod.querySelector('.choose_txt[data-period="' + newPeriod + '"]').classList.add('selected');

        slider.setAttribute('data-period', newPeriod);

        innerObject.tooglePrice(newPeriod, lastPeriod);
        innerObject.toogleButtons(newPeriod, lastPeriod);

        let suggestCaption = document.querySelector('.caption');
        suggestCaption.setAttribute('data-period', newPeriod);

        let individualBlock = document.querySelector('.payment-body-container-block.block-individual');
        let individualBlockBtn = individualBlock.querySelector('.payment-body-container-block-button');
        let teamBlock = document.querySelector('.payment-body-container-block.best-plan');


        if (newPeriod === 'month') {
          innerObject.timeout = setTimeout(function () {
            if (document.querySelector('.payment-body-header-tooltip')) {
              const tooltip = document.querySelector('.payment-body-header-tooltip')
              tooltip.style.display = 'block';
            }
          }, 500); // was 3000

          var elems = document.querySelectorAll('.payment-body-container-block-upto');
          for (var i = 0; i < elems.length; i++) {
            elems[i].style.transform = 'translateY(-6px)';
          }

          individualBlock.classList.add('radio-choose-month-individual');
          individualBlockBtn.classList.add('disabled-plan-button');
          teamBlock.classList.add('radio-choose-month-individual');
          document.querySelector(".payment-body-container-block-button[data-period='year']").classList.add('hidden');
          document.querySelector(".payment-body-container-block-button[data-period='month']").classList.remove('hidden');
          individualBlockBtn.innerHTML = __("payment_individual_month_button");
        } else {
          innerObject.timeout && clearTimeout(innerObject.timeout);
          document.querySelector('.payment-body-header-tooltip').style.display = '';

          var elems = document.querySelectorAll('.payment-body-container-block-upto');
          for (var i = 0; i < elems.length; i++) {
            elems[i].style.transform = 'translateY(0)';
          }

          document.querySelector(".payment-body-container-block-button[data-period='year']").classList.remove('hidden');
          document.querySelector(".payment-body-container-block-button[data-period='month']").classList.add('hidden');
          individualBlock.classList.remove('radio-choose-month-individual');
          individualBlockBtn.classList.remove('disabled-plan-button');
          teamBlock.classList.remove('radio-choose-month-individual');
        }

        innerSettings.paymentPeriod = newPeriod;
        let newPlan = suggestCaption.getAttribute('data-plan');
        let dataMore = suggestCaption.getAttribute('data-more') || suggestCaption.closest('.best-plan').classList.contains('boldCheck');
        //////
        app.trigger('changePayment', newPlan, newPeriod, '', dataMore, true);
      };
    },
    tooglePrice: function (newPeriod, lastPeriod) {
      var newPrice = document.querySelector(".block__price[data-period='" + newPeriod + "']");
      var lastPrice = document.querySelector(".block__price[data-period='" + lastPeriod + "']");

      while (newPrice) {
        newPrice.classList.remove('hidden');

        newPrice = document.querySelector(".block__price.hidden[data-period='" + newPeriod + "']");
      }

      while (lastPrice) {
        lastPrice.classList.add('hidden');

        lastPrice = document.querySelector(".block__price[data-period='" + lastPeriod + "']:not(.hidden)");
      }
    },
    toogleButtons: function (newPeriod, lastPeriod) {
      var newPeriodButton = document.querySelector(".block__price[data-period='" + newPeriod + "']");
      var lastPeriodButton = document.querySelector(".block__price[data-period='" + lastPeriod + "']");

      this.showOrHideNote(newPeriod);

      while (newPeriodButton) {
        newPeriodButton.classList.remove('hidden');

        newPeriodButton = document.querySelector(".block__price.hidden[data-period='" + newPeriod + "']");
      }
      while (lastPeriodButton) {
        lastPeriodButton.classList.add('hidden');

        lastPeriodButton = document.querySelector(".block__price[data-period='" + lastPeriod + "']:not(.hidden)");
      }
    },
    showOrHideNote: function (newPeriod) {
      var selector = '.payment-body-container-block-price-note-value-annual';
      var method = newPeriod === 'month' ? 'add' : 'remove';

      _.each(document.querySelectorAll(selector), function (element) {
        element.classList[method]('isVisible');
      });
    },
    tabsStudentLeft: function () {
      var left = document.querySelector('.js-tabs-left');
      var right = document.querySelector('.js-tabs-right');

      if (right.classList.contains('active-right')) {
        document.querySelector('.student-main-container').classList.remove('student-main-container-right');
        document.querySelector('.student-main-container').classList.add('student-main-container-left');
        right.classList.remove('active-right');
        document.querySelector('.after-line').classList.remove('js-after-line-right');
        document.querySelector('#right').classList.remove('js-show-student-main-content-right');
        document.querySelector('#left').classList.add('js-show-student-main-content-left');
      }
      if (left.classList.contains('active-left')) {
      } else {
        right.classList.remove('active-right');
        left.classList.add('active-left');
      }
    },
    tabsStudentRight: function () {
      var left = document.querySelector('.js-tabs-left');
      var right = document.querySelector('.js-tabs-right');

      if (left.classList.contains('active-left')) {
        document.querySelector('.student-main-container').classList.remove('student-main-container-left');
        document.querySelector('.student-main-container').classList.add('student-main-container-right');
        left.classList.remove('active-left');
        document.querySelector('.after-line').classList.add('js-after-line-right');
        document.querySelector('#left').classList.remove('js-show-student-main-content-left');
        document.querySelector('#right').classList.add('js-show-student-main-content-right');
      }
      if (right.classList.contains('active-right')) {
      } else {
        left.classList.remove('active-right');
        right.classList.add('active-right');
      }
    },
    initButtonBuyClick: function () {
      var buttonBuyArray = document.getElementsByClassName("payment-body-container-block-button"), buttonClickHandler = function (e) {};
      _.each(buttonBuyArray, function (button) {
        button.onclick = buttonClickHandler.bind(this, []);
      });
    },
    getMainPaymentTemplate: function (fullScreen, isTeamLayout) {
      // return innerTemplates.getPaymentBodyContainer(isTeamLayout);
      return innerTemplates.getPaymentBodyBusiness() + innerTemplates.getPaymentFooterBusiness();
    },
    getMainPaymentTemplateHeader: function (fullScreen, isTeamLayout) {
      return innerTemplates.getPaymentHeader()
    },
    getMainPaymentTemplateStudent: function (fullScreen, isTeamLayout) {
      return innerTemplates.paymentPlanStudentHero() + innerTemplates.paymentPlanStudentMain() + innerTemplates.paymentPlanStudentBottom();
    },

    getMainPaymentTemplateStudentHeader: function (fullScreen, isTeamLayout) {
      return innerTemplates.paymentPlanStudentHeroHeader()
    },
    beautifyPrice:function (price) {
      if(price % 1 !== 0){
        let arrPrice = price.toString().split('.');
        return `${arrPrice[0]}.<small>${arrPrice[1]}</small>`;
      }
      else {
        return Number(price).toFixed(0);
      }
    },
    momentFormat: function(){
      let momentFormat = moment(user.affiliate.startTime).add(user.affiliate.couponValidDays, 'day');
      if (user.locale === 'kr') {
        return momentFormat.locale('ko').format('MMM Do');
      } else if (user.locale === 'ru') {
        return momentFormat.locale('ru').format('Do MMMM');
      } else if ( user.locale === 'es'){
        return momentFormat.locale(user.locale).format('MMM').toLowerCase() + ' ' + momentFormat.locale(user.locale).format('D');
      }
      else if (user.locale === 'pt'){
        return momentFormat.locale(user.locale).format('MMM.').toLowerCase() + ' ' + momentFormat.locale(user.locale).format('D');
      } else if (user.locale === 'en'){
        return momentFormat.locale('en').format('MMM. Do');
      } else {
        return momentFormat.locale(user.locale).format('MMM D');
      }
    }
  };

  return innerObject;
})();
